export { default } from './tag'
export type { Props as TagProps } from './tag'
